import React from 'react';
interface SectionProps {
  children: ReactNode;
  className?: string;
  id?: string;
  background?: 'white' | 'cream' | 'green';
}
export function Section({
  children,
  className = '',
  id,
  background = 'white'
}: SectionProps) {
  const bgColors = {
    white: 'bg-white',
    cream: 'bg-[#F4E4C1]/30',
    green: 'bg-[#2D5016] text-white'
  };
  return <section id={id} className={`py-12 md:py-20 ${bgColors[background]} ${className}`} data-id="element-1286">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl" data-id="element-1287">{children}</div>
    </section>;
}